/**
 * Product photos come from the website's media: Cloudinary URLs (sized with transforms), older
 * Openinary paths, or plain URLs. Same rules as the storefront's mediaUrl.
 */
import { API_BASE } from "./api";

const OPENINARY = "https://cdn.openinary.dev/b/40404d68-f5a2-405d-bff1-d2f36728b8c2/t";

export function mediaUrl(src: string | null | undefined, w = 240): string {
  if (!src) return "";
  if (/^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(src)) return src.replace("/image/upload/", `/image/upload/w_${w},f_auto,q_auto/`);
  if (/^(https?:)?\/\//.test(src) || src.startsWith("data:") || src.startsWith("blob:")) return src;
  if (src.startsWith("/media/")) return API_BASE + src;
  const path = src.replace(/^\/+/, "").split("/").map(encodeURIComponent).join("/");
  // Openinary answers resized requests (w_…) with 402 on the current plan, which left the logo and
  // product photos blank; the original file is served fine, so ask for that. `w` still sizes
  // Cloudinary images above.
  void w;
  return `${OPENINARY}/${path}`;
}
